import { EDChestPainFormatter } from './edChestPain01/EDChestPain-Formatter';
import { GPChestPainFormatter } from './gpChestPain01/GPChestPain-Formatter';
import { GallbladderFormatter } from './Gallbladder01/GallbladderFormatter';
import moment from 'moment';
import { OsteoporosisFormatter } from './dxaScan01/Osteoporosis-Formatter';
import { ACCMRIFormatter } from './accmri01/ACCMRI-Formatter';
import { ACCBISTFormatter } from './concussion01/ACCBIST-Formatter';

export class PathwayFormatter {
    static formatAsPlainText(pathwayId, workflow, actions){
        switch(pathwayId){
            case 'chestPain01':
                return EDChestPainFormatter.formatAsPlainText(workflow, actions);
            case 'gallbladder01':
                return GallbladderFormatter.formatAsPlainText(workflow, actions);
            case 'dxaScan01':
                return OsteoporosisFormatter.formatAsPlainText(workflow, actions);
            case 'gpChestPain01':
                return GPChestPainFormatter.formatAsPlainText(workflow, actions);
            case 'accmri01':
                return ACCMRIFormatter.formatAsPlainText(workflow, actions);
            case 'accbist01':
                return ACCBISTFormatter.formatAsPlainText(workflow, actions);
            case 'QuidelOrtho':
                return EDChestPainFormatter.formatAsPlainText(workflow, actions);
            default: 
                return '';
        }
    }

    static formatDate(date, format) {
        if (date == null) { return null; }
        return moment(date).format(format);
    }
}


// WEBPACK FOOTER //
// ./src/forms/PathwayFormatter.js